import { URL, LONG_URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import Notification from '../../handlers/Notification';

const getCompany  = () => {
    return (dispatch, getState) => {
        
        if (window.location.pathname === '/') {
            dispatch({type: "WAIT_FOR_RESPONSE"});
        }
        let host = LONG_URL;
        if( localStorage.getItem("companyId") ){
            host = `${URL}${localStorage.getItem("companyId")}`;
        }           

        return axios.get( host ).then( async (res) => {

			let currencies, local_currency, international_currency;
			await axios.get( URL + res.data.id + '/currencies')  /// TODO: MALDITO JAVASCRIPT porque me haces hacer esto...
				.then( res => {
					currencies = res.data
				})
				.catch(err => 
					console.log("Error: No se pudo acceder al servidor para la lista de monedas usadas por la compañía, se esta usando el $ como simbolo por defecto, pero esto indica que exploto")
				)

			// de la lista de currencies que tiene la company tomo la que este definida como local (es la usada por defecto para los productos) y la internacional
			local_currency = currencies.data.find(cur => cur.is_local);
			international_currency = currencies.data.find(cur => cur.is_international);

            var customEmailFooter=
                res.data &&
				res.data.custom_json &&
				res.data.custom_json.mail_footer
				? res.data.custom_json.mail_footer
				: '';

            var customClientBg=
                res.data &&
                res.data.custom_json &&
                res.data.custom_json.customClientBg
                ? res.data.custom_json.customClientBg
                : '';

            dispatch({
                type: 'COMPANY_INITIALIZATION',
                company: res.data,
                initCompany: res.data,
                lang_code: localStorage.getItem('lang_code') || res.data.default_iso_lang,
                company_styles_json:res.data.styles_json.styles,
				currencies: {
					local: local_currency,
					international: international_currency,
					accepted: currencies.data
				},
				customEmailFooter: customEmailFooter,
                customClientBg:customClientBg,
            })
            localStorage.setItem("companyId", res.data.id);
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:store.getState().json_lang.custom_errors.retrieving_company});
            //window.location.replace('/404');
        });
    }
}

const getCountries = () => {
    return (dispatch, getState) => {
        return axios.get( `${URL}${localStorage.getItem("companyId")}/countries` ).then( async (res) => {
            // console.log("getCountries",res)
            dispatch({
                type: 'GET_COUNTRIES',
                countries: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:store.getState().json_lang.custom_errors.retrieving_company});
        });
    }
}


/* This method allows to know when the sidebar or the aside menu are open */
const onResize = (isSidebarActive, isAsidemenuActive) => {
    if(isSidebarActive !== undefined){
        return {
            type: "ON_RESIZE_LISTENER",
            isSidebarActive: !isSidebarActive
        }
    }
    if (isAsidemenuActive !== undefined) {
        return {
            type: "ON_RESIZE_LISTENER",
            isAsidemenuActive: !isAsidemenuActive
        }
    }
}

export {
    getCompany,
    getCountries,
    onResize
};


// WEBPACK FOOTER //
// ./src/store/actions/initialState.js